// vim: set ts=2 sts=2 sw=2 et:

export type JudgePosition = "J1" | "J2" | "J3";
export type JudgeVoteValue = "good" | "noLift";

export type JudgeVotes = Partial<Record<JudgePosition, JudgeVoteValue>>;

export const JUDGE_POSITIONS: ReadonlyArray<JudgePosition> = ["J1", "J2", "J3"];

export const resolveJudgeVotes = (votes: JudgeVotes): boolean | null => {
  const voteValues = JUDGE_POSITIONS.map((position) => votes[position]).filter(
    (vote): vote is JudgeVoteValue => typeof vote === "string",
  );

  if (voteValues.length < JUDGE_POSITIONS.length) {
    return null;
  }

  const goodVotes = voteValues.filter((vote) => vote === "good").length;
  return goodVotes >= 2;
};
